import { useAuth } from '../context/AuthContext';

/**
 * Custom hook to detect if user is in instructor mode
 * Instructor mode is active when:
 * - User is authenticated (logged in)
 * 
 * In instructor mode:
 * - Bypass 10:30 AM MT visibility restriction
 * - Show future playlists
 * - Show BPM data (grayed out, italic)
 * - Access to Library, Generator, Sync
 */
export function useInstructorMode() {
  const { isAuthenticated, loading: authLoading } = useAuth();
  
  // Instructor mode = authenticated user
  const isInstructorMode = isAuthenticated;
  
  /**
   * Build a URL (no longer needs special params since auth is cookie-based)
   * @param {string} path - The base path (e.g., '/playlist/123')
   * @returns {string} - Same path (auth is handled by cookies)
   */
  const buildUrl = (path) => {
    return path;
  };
  
  /**
   * Get backend API parameter for showing all playlists
   * Backend uses ?show=all for authenticated users
   * @returns {string} - Query string for backend API (e.g., '&show=all' or '')
   */
  const getBackendParam = () => {
    return isInstructorMode ? '&show=all' : '';
  };
  
  return {
    isInstructorMode,
    authLoading,
    buildUrl,
    getBackendParam
  };
}
